// Keep guide slugs separate from page copy for the lightweight route bundle.
export const DESTINATION_GUIDE_SLUGS = [
  "southwest-florida-moving-delivery-guide",
  "southeast-florida-moving-delivery-guide",
  "central-florida-the-villages-moving-delivery-guide",
  "nyc-moving-delivery-guide",
  "westchester-long-island-moving-delivery-guide",
  "dallas-north-moving-delivery-guide",
  "houston-hill-country-moving-delivery-guide",
  "phoenix-valley-moving-delivery-guide",
  "colorado-front-range-moving-delivery-guide",
  "southern-california-moving-delivery-guide",
  "bay-area-moving-delivery-guide",
  "chicago-long-distance-moving-checklist",
];
